import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export const Featured = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } })
      .then((r) => setItems(Array.isArray(r.data) ? r.data.slice(0, 5) : []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  const [first, ...rest] = items;

  return (
    <section data-testid="featured-section" className="mx-auto max-w-[1600px] px-5 py-24 md:px-10 md:py-36">
      <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <Reveal>
          <p className="eyebrow">The Edit — {items.length} pieces</p>
          <h2 className="mt-4 font-display text-5xl font-light leading-none md:text-7xl">Built in <em>volume.</em></h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link to="/shop" data-testid="featured-view-all" className="link-underline text-sm">View all garments →</Link>
        </Reveal>
      </div>
      <div className="grid gap-x-6 gap-y-14 md:grid-cols-12">
        <Reveal className="md:col-span-6 md:row-span-2">
          <ProductCard product={first} index={0} tall />
        </Reveal>
        {rest.map((p, i) => (
          <Reveal key={p.product_id} delay={(i % 2) * 0.12} className="md:col-span-3">
            <ProductCard product={p} index={i + 1} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
